import React, { useState, useEffect } from 'react';
import gsap from 'gsap';
import Slider from 'react-slick';

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Slick carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Styles
import './Blogs.css';

// Images
import heroImage2 from '../../assets/hero/hero.jpg';
import heroImage3 from '../../assets/hero/hero3.jpg';

import adventure from '../../assets/categories/adventure.jpg';
import vr from '../../assets/categories/vr.jpg';
import story from '../../assets/categories/story.jpg';
import cultural from '../../assets/categories/cultural.jpg';
import photo from '../../assets/categories/photo.jpg';
import sports from '../../assets/categories/sports.jpg';
import retreats3 from '../../assets/categories/retreats3.jpg';
import community from '../../assets/categories/community.jpg';
import historical from '../../assets/categories/historical.jpg';
import nature2 from '../../assets/categories/nature2.jpg';
import group from '../../assets/categories/group.jpg';
import culinary from '../../assets/categories/culinary.jpg';
import outdoor from '../../assets/categories/outdoor.jpg';
import farming from '../../assets/categories/farming.jpg';
import art from '../../assets/categories/art.jpg';
import artisan from '../../assets/categories/artisan.jpg';
import music from '../../assets/categories/music.jpg';
import wildlife from '../../assets/categories/wildlife.jpg';

const VacationPage = () => {
  const [fontSize, setFontSize] = useState('2.5rem');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 480) setFontSize('1.5rem');
      else if (window.innerWidth < 768) setFontSize('2rem');
      else setFontSize('2.5rem');
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cards = [
    {
      name: "🥘 Culture & Cuisine",
      description: "Dive into rich traditions, flavors, and artistic expressions from around the world.",
      image: culinary,
      link: "/culture-cuisine",
    },
    {
      name: "🌿 Nature & Wellness",
      description: "Reconnect with nature, wellness, and mindful journeys in serene environments.",
      image: nature2,
      link: "/nature-wellness",
    },
    {
      name: "🧭 Adventure & Exploration",
      description: "Thrilling escapades and hidden gems await the bold explorer in you.",
      image: adventure,
      link: "/adventure-exploration",
    },
    {
      name: "🌍 Community & Impact",
      description: "Be part of meaningful travel that uplifts communities and creates change.",
      image: community,
      link: "/community-impact",
    },
    {
      name: "🕶️ Virtual & Interactive",
      description: "Experience the world through immersive and tech-powered travel formats.",
      image: vr,
      link: "/virtual-interactive",
    },
    {
      name: "⚽ Sports & Action",
      description: "Fuel your adrenaline with sporting events and action-packed activities.",
      image: sports,
      link: "/sports-action",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    customPaging: (i) => <button>{i + 1}</button>,
    appendDots: (dots) => <div><ul className="custom-dots">{dots}</ul></div>,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } }
    ]
  };

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return <div className={className} style={{ ...style, background: 'gray', borderRadius: '50%' }} onClick={onClick} />;
  }

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return <div className={className} style={{ ...style, background: 'gray', borderRadius: '50%' }} onClick={onClick} />;
  }

  return (
    <div className="container-fluid">
      <main>
        <section className="destination-showcase" style={{ position: 'relative' }}>
          <h1 style={{
            fontSize,
            fontWeight: '800',
            background: 'linear-gradient(45deg, #4A90E2, #FEB47B)',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            marginBottom: '16px',
          }}>
            Explore All Categories
          </h1>

          <Slider {...settings}>
            {cards.map((card, index) => (
              <div key={index} className="card-wrapper">
                <div
                  className={`category-card category-${card.name.replace(/\s+/g, '-').toLowerCase()}`}
                  style={{
                    backgroundImage: `url(${card.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '350px',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'flex-end',
                  }}
                >
                  <div className="card-content" style={{
                    background: 'rgba(0,0,0,0.5)',
                    color: '#fff',
                    padding: '20px',
                    width: '100%',
                    borderBottomLeftRadius: '15px',
                    borderBottomRightRadius: '15px'
                  }}>
                    <h3 className="card-title">{card.name}</h3>
                    <p className="card-description" style={{ color: '#FFD700', fontWeight: 'bold' }}>
                      {card.description}
                    </p>
                    <a href={card.link} className="explore-btn" style={{ fontWeight: 'bold', letterSpacing: '1px', color: '#fff', textDecoration: 'underline' }}>
                      Plan My Adventure
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Slider>

          <a href="/all-places" style={{
            position: 'absolute',
            bottom: '-10px',
            right: '20px',
            padding: '5px 10px',
            backgroundColor: '#007BFF',
            color: '#fff',
            borderRadius: '5px',
            textDecoration: 'none',
            fontWeight: 'bold'
          }}>
            View All Places
          </a>
        </section>
      </main>
    </div>
  );
};

export default VacationPage;
